import * as React from "react";

import { useForgotPasswordForm } from "../providers";

export const PageSuccess: React.FunctionComponent = () => {
  const { form: forgotPasswordForm } = useForgotPasswordForm();

  return (
    <div className="page page-success">
      <h2>{`Your reset password link has been sent.`}</h2>
      <h5 className="instructions">{`Your should receive a reset password link at the email address below. Please open that link to reset your password.`}</h5>
      <p>{forgotPasswordForm.email || ""}</p>
      <hr />
      <h4>{`Didn’t receive a link?`}</h4>
      <h5>{`1. Check that the email above is spelt correctly.`}</h5>
      <h5 className="didnt-receive-advice-second-piece">{`2. Make sure that the email above is the one you use for your Bed Bath N’ Table account.`}</h5>
      <h5>{`3. Check your email spam folder.`}</h5>
      <a href="/customer/account/login">
        <button>{`BACK TO SIGN IN`}</button>
      </a>
    </div>
  );
};

